import React, { useState } from 'react';
import RadarChart from 'react-svg-radar-chart';
import 'react-svg-radar-chart/build/css/index.css';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { toysState, replayState } from '../../state';
import styled from 'styled-components';
import { gameProgressState } from '../../state';
import { FacebookShare } from '../../components/common/facebook';

const ChartWrapper = styled.div`
  & text.caption {
    cursor: pointer;
    font-weight: 600;
    fill: #0071bc;
  }
`

const captions = {
  environment: '環境保育',
  society: '　　　社會福祉',
  life: '　永續生活',
  land: '土地文化　',
  education: '優質教育　　　'
};

const toyValueMap = {
  wheelchair: 'society',
  frog: 'environment',
  tai: 'environment',
  recyclebox: 'life',
  donate:'society',
  scdclothes: 'life',
  gugu:'life',
  COVID:'society',
  pangolin: 'environment',
  boat: 'land',
  dog:'education',
  sport:'education',
  toy:'education',
  cow:'land',
  stonehouse:'land',
};

const chartOptions = {
  captionMargin: 60,
  captionProps: () => ({
    className: 'caption',
    textAnchor: 'middle',
    fontSize: 16,
    fontFamily: 'sans-serif',
  }),

};

const toRadarData = (toys) => {
  const radarData = {
    environment: 0.1,
    society: 0.1,
    life: 0.1,
    land: 0.1,
    education: 0.1
  };
  toys.forEach(({ id, selected }) => {
    if (selected) {
      if (id==='01') {
        radarData.life += 0.35;
        radarData.society += 0.15;
      } else if (id==='02') {
        radarData.life += 0.4;
        radarData.environment += 0.1;
      } else if (id==='03') {
        radarData.society += 0.35;
        radarData.education += 0.15;
      } else if (id==='04') {
        radarData.environment += 0.35;
        radarData.land += 0.15;
      } else if (id==='05') {
        radarData.environment += 0.4;
        radarData.life += 0.1;
      } else if (id==='06') {
        radarData.society += 0.4;
        radarData.land += 0.1;
      } else if (id==='07') {
        radarData.land += 0.35;
        radarData.life += 0.15;
      } else if (id==='08') {
        radarData.land += 0.4;
        radarData.education += 0.1;
      } else if (id==='09') {
        radarData.education += 0.4;
        radarData.environment += 0.1;
      } else if (id==='10') {
        radarData.education += 0.35;
        radarData.society += 0.15;
      }
      radarData[toyValueMap[id]] += 0;
    }
  })

  return [
    {
      data: radarData,
      meta: { color: '#8ec44a' }
    }
  ]
};

const maxToyValue = (toys) => {
  const radarData = {
    environment: 0.1,
    society: 0.1,
    life: 0.1,
    land: 0.1,
    education: 0.1
  };
  toys.forEach(({ id, selected }) => {
    if (selected) {
      if (id==='01') {
        radarData.life += 0.35;
        radarData.society += 0.15;
      } else if (id==='02') {
        radarData.life += 0.4;
        radarData.environment += 0.1;
      } else if (id==='03') {
        radarData.society += 0.35;
        radarData.education += 0.15;
      } else if (id==='04') {
        radarData.environment += 0.35;
        radarData.land += 0.15;
      } else if (id==='05') {
        radarData.environment += 0.4;
        radarData.life += 0.1;
      } else if (id==='06') {
        radarData.society += 0.4;
        radarData.land += 0.1;
      } else if (id==='07') {
        radarData.land += 0.35;
        radarData.life += 0.15;
      } else if (id==='08') {
        radarData.land += 0.4;
        radarData.education += 0.1;
      } else if (id==='09') {
        radarData.education += 0.4;
        radarData.environment += 0.1;
      } else if (id==='10') {
        radarData.education += 0.35;
        radarData.society += 0.15;
      }
      radarData[toyValueMap[id]] += 0;
    }
  })

  let MaxToycaption='環境保育';
  let Maxtoy=radarData.environment;
  if(Maxtoy<radarData.society){
    MaxToycaption='社會福祉';
    Maxtoy=radarData.society;
  }
  if(Maxtoy<radarData.life){
    MaxToycaption='永續生活';
    Maxtoy=radarData.life;
  }
  if(Maxtoy<radarData.land){
    MaxToycaption='土地文化';
    Maxtoy=radarData.land;
  }
  if(Maxtoy<radarData.education){
    MaxToycaption='優質教育';
    Maxtoy=radarData.education;
  }

  return(
    MaxToycaption
  );
};

const Result = () => {
  const [targetCaptionKey, setTargetCaptionKey] = useState(null)
  const toys = useRecoilValue(toysState);
  const setReplay = useSetRecoilState(replayState);
  const setGameProgress = useSetRecoilState(gameProgressState);

  const onCaptionClick = ({ target }) => {
    if (target.getAttribute('class') === 'caption') {
      const caption = Object.entries(captions).find(([key, value]) => value === target.textContent)
      if (caption) {
        setTargetCaptionKey(caption[0])
        setGameProgress(caption[0])
      }
    }
  }

  if (targetCaptionKey) {
    return (
      <ResultDetail
        captionKey={targetCaptionKey}
        onClose={() => setTargetCaptionKey(null)}
      />
    )
  }

  const toyResult = maxToyValue(toys);

  const FbShareContent = (toyResult) => {
    if (toyResult === '環境保育'){
      return "為臺灣做一件好事，我測出來的結果是──環境保育人！\n\n臺灣的文化多元、物種豐富\n然而，還有許多珍貴的生物需要你我齊心守護\n用一顆熱愛大自然和動植物的心，來為臺灣的環境保育出一份力吧！";
    } else if (toyResult === '社會福祉'){
      return "為臺灣做一件好事，我測出來結果是──社會福祉人！\n\n相信有愛就能改變社會，一點點的善心，就能讓世界變得更美好\n這份美好，也將回饋到你我身上\n新的一年，一起來付諸行動分享愛吧！";
    } else if (toyResult === '永續生活'){
      return "為臺灣做一件好事，我測出來的結果是──永續生活人！\n\n了解氣候變遷對人類和地球帶來的影響，\n希望可以從自身開始，成為改變現況的力量\n朋友們，新的一年跟我一起為臺灣的永續生活出一份力吧！";
    } else if (toyResult === '土地文化'){
      return "為臺灣做一件好事，我測出來的結果是──土地文化人！\n\n身為土地文化人的我，對於臺灣這片土地有著深厚的情感，\n也熱愛著這座島嶼上的人事物\n新的一年，我打算踏出第一步，為臺灣的土地文化出一份力！";
    } else if (toyResult === '優質教育'){
      return "為臺灣做一件好事，我測出來的結果是──優質教育人！\n\n深信改變要從教育開始做起\n你我都可以是議題的倡議者，促成討論，讓社會變得更好\n新的一年，挑選一個感興趣的議題，深入了解吧！";
    }
  };


  return (
    <>
      <div className="result-title">
        <h2>哇！依照你選出的卡片，<br/>是位對 <span className="result-title-type">{toyResult}</span> <br className="mobile-br" />感興趣的朋友啊！</h2>
          （點選<span className="result-caption-sample">下方藍色指標連結</span>，可以看到各項指標的好人好事唷！）
      </div>
      <ChartWrapper onClick={onCaptionClick}>
        <RadarChart
          captions={captions}
          data={toRadarData(toys)}
          size={290}
          options={chartOptions}
        />
      </ChartWrapper>
      <FacebookShare
        href="https://goodthings.homeruntaiwan.com/"
        quote={FbShareContent(toyResult)}
      />
      <button onClick={() => setReplay()} className="intro-botton">再測一次</button>
    </>
  );
};

const ResultDetail = ({
  captionKey,
  onClose
}) => {
  return (
    <div>
      <b>{captions[captionKey]}</b>
      <button onClick={onClose}>back</button>
    </div>
  )
}

export {
  Result
}
